import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '.';

const CommentCard = ({ comment, isAdmin }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const isOwner = comment.usuario.id === user.id;
  return (
    <Card className="comment-card v-md-margin">
      {isOwner && (
        <h2>
          <strong>{comment.bloco}</strong>
          {' '}
          - Você enviou um Feedback
        </h2>
      )}
      {!isOwner && (
        <h2>
          <strong>{comment.bloco}</strong>
          {' '}
          -
          {comment.usuario.nome}
          {' '}
          {comment.usuario.sobreNome}
          {' '}
          enviou um Feedback
        </h2>
      )}
      <span className="create-at">{comment.data}</span>

      {isAdmin && (
        <div>
          <button className="h-sm-margin" type="submit">
            <i className="material-icons">edit</i>
          </button>
          <button type="submit">
            <i className="material-icons">delete_forever</i>
          </button>
        </div>
      )}

      {comment.observacao && (
        <div className="v-sm-margin">
          <p>
            <strong>Observação</strong>
          </p>
          <p dangerouslySetInnerHTML={{ __html: comment.observacao && comment.observacao.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, "<br />") }} />
        </div>
      )}

      {comment.sugestao && (
        <div className="v-sm-margin">
          <p>
            <strong>Sugestão</strong>
          </p>
          <p dangerouslySetInnerHTML={{ __html: comment.sugestao && comment.sugestao.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, "<br />") }} />
        </div>
      )}
    </Card>
  );
};
CommentCard.propTypes = {
  isAdmin: PropTypes.bool,
};
CommentCard.defaultProps = {
  isAdmin: false,
};

export default CommentCard;



// WEBPACK FOOTER //
// ./src/components/CommentCard.js